var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    width: 33,
    height: 33,
    fill: "url(#pattern0_1003_4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 40L11.84 12H16.24L27 40H22.4L16 23.12C15.92 22.9333 15.76 22.48 15.52 21.76C15.3067 21.04 15.0533 20.24 14.76 19.36C14.4667 18.48 14.2 17.68 13.96 16.96C13.72 16.2133 13.56 15.7333 13.48 15.52L14.4 15.48C14.24 15.9333 14.04 16.5067 13.8 17.2C13.5867 17.8933 13.3467 18.6267 13.08 19.4C12.84 20.1733 12.6 20.9067 12.36 21.6C12.12 22.2667 11.92 22.8267 11.76 23.28L5.4 40H1ZM5.8 33.04L7.4 28.88H20.12L21.96 33.04H5.8ZM30.8878 40V36H35.4078V16H30.8878V12H44.2478V16H39.7278V36H44.2478V40H30.8878Z",
    fill: "#5070D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1003_4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1003_4",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1003_4",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADCElEQVR4nOVaW2sTQRSeIF7wgj/EH2AFwSchXnYmVfpSxUd/hz/AFny0vlWfigVRe05ENH+gD31ozgle0FoQWsWItGqeRs4m0W26m2x3Z7OdemBpkm7Ozjfznct8E6X+S7O2ooEacslr5avVkM4ZZCtXADShfDWDPNsHYoBnlLe0Qv7YB6KBP3lJr1qEVl7Ty0Rp5S297E5aeUuvWgyt/KKXtRUZqAHCJCDyvxDMflyZAJtnDPIdA/w2EUAMzQzQvRq0zpcHyvZnnmcM8FrawSevEq+JrzQrZaB52SB9kb8qr0nLkXvwydR7PfTZSBCuKBJ4C2Tq5fvTGrnTBcIdeV9KXOSNlwBaNwe+dyM3kDKC3QAv7vRBj5Vv6ffq0+XjBnl7wN+2fF4MmJACNJG4Es+bZ7P4NHW+HucvQLqmfGpRDNKj2IlBeugeQPTBUmN2AaG7WXzdXl4+bJC/xccafZ9aWD2ixkmvzLQKi2By4qgttS4pHzZWGvjBiCw4p8ZGr4x7EaGVBtoYnsppQ+5T46DXXmg1tWAPSX2ROqOBP6esS1818LwBDqrw5qhbJNZWpOUI244RtJJ6IKlUspBGbufqFJDb4kf8FVpnooOXGQxnEulH3lbHxKfnnxr4mV6iW056s6hppCvSvfYbwHFdGrkTds8utgA9IJvjBGB2r9KmEyAyIwdiRQ5MjMTZhcaHY31QebOWAd76O/jG6kmVVX1Pk26HmfROQb1VlYqdNp509745+V7u3itaAF3pV6VUdlOQ+i4zPSKI7zuu4v+kIY207kqvku52GJCg3qq6eE7h6vvQ/Qhy2+l+pGj1XXqn+Pjg+fzera30VmJWdmoxQSifzco9eWmmgSYTAn0yt/yjkd7toTCt59F6e8Vza8Dv9sUXKyfKUxlHyKJpdS0DvJgJROlA6jy9w0+dp5WPxwj6CZ8yQL+6Pum3u94pcryQGOwpjwvSmlM1Pq2OVcThZ/98pDAJKHCoY5Vr9oD8QGCQXlnl0X1hQUYda/+ZtRWD9Eoub2mlPLM/pAFRfs/rlr4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.4c8c4312d56fbc07759cf3f899ac2c13.svg";
export { ForwardRef as ReactComponent };